import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
      default: _withCtx(() => [
        _createTextVNode(" Êtes-vous sûr(e) de vouloir l'associer à un " + _toDisplayString(_ctx.getCurrentAccountTitle) + "? ", 1),
        (_ctx.step)
          ? (_openBlock(), _createBlock(_component_v_avatar, {
              key: 0,
              color: "primary lighten-2",
              class: "subheading white--text",
              size: "24",
              textContent: _toDisplayString(_ctx.step)
            }, null, 8, ["textContent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, {
          wrap: "",
          xs12: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select_filled, {
              items: _ctx.currentAccountUsers,
              "item-title": _ctx.getUserDisplayName,
              "item-value": "id",
              label: "Associé",
              modelValue: _ctx.currentAccountUser,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentAccountUser) = $event)),
              "return-object": "",
              outlined: "",
              readonly: _ctx.currentAccountUsers.length <= 1
            }, null, 8, ["items", "item-title", "modelValue", "readonly"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.actions)
      ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
              style: {"margin":"center"},
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step ? "Précédent" : "Annuler"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _ctx.linkWithCurrentAccount,
              loading: _ctx.loading,
              size: "small"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Oui, je suis sûr(e)")
              ])),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}